exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ck-content{height:150px;overflow-y:auto}", ""]);

// exports
